"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./Toolkit/setPrimeReactLang");
var _react = _interopRequireWildcard(require("react"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _calendar = require("primereact/calendar");
var _api = require("primereact/api");
var _hi = require("react-icons/hi");
var _lu = require("react-icons/lu");
var _luxon = require("luxon");
var _DateVisualHelper = _interopRequireDefault(require("./Toolkit/DateVisualHelper"));
var _InputMask = _interopRequireDefault(require("./Toolkit/InputMask"));
var _mask_configs = _interopRequireDefault(require("./Toolkit/DateFunctions/mask_configs"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _nodeIsOrBelongsTo = _interopRequireDefault(require("Functions/nodeIsOrBelongsTo"));
var _arePropsEqual = _interopRequireDefault(require("Functions/arePropsEqual"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const prime_params = {
  unstyled: true
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(function DatePicker({
  removeError,
  name,
  onChange,
  ...props
}) {
  const default_value = props['default-value'] || '';
  const onEnter = props.onEnter;
  const type = 'legacy';
  if (name === 'candidate[monitoring][mde735y0][date]') {
    console.log('DataPicker', props.value);
  }
  const MASK_CONFIG = (0, _react.useMemo)(function () {
    const MASK_CONFIG_NAME = Object.keys(_mask_configs.default).find(name => _mask_configs.default[name].format === props.mask);
    return _mask_configs.default[MASK_CONFIG_NAME] || _mask_configs.default.french;
  }, [props.mask]);
  const is__disabled = props['read-only'];
  const container_ref = (0, _react.useRef)();
  const input_ref = (0, _react.useRef)();
  const input_value_ref = (0, _react.useRef)();
  const background_ref = (0, _react.useRef)();
  const id = (0, _react.useMemo)(function () {
    return (0, _uniqid.default)();
  }, []);
  const [is__visible, setVisibility] = (0, _react.useState)(false);
  const [mask_text, setMaskText] = (0, _react.useState)('');
  const [user_value, setUserValue] = (0, _react.useState)('');
  const [calendar_date, setCalendarDate] = (0, _react.useState)('');
  const modifiers = (0, _react.useMemo)(function () {
    const modifiers = (props.bemit || []).concat(props.error ? ['error'] : []);
    if (is__disabled) modifiers.push('disabled');
    if (MASK_CONFIG.format === 'YYYY') modifiers.push('year');
    if (props.type === 'week') modifiers.push('week');
    return modifiers;
  }, [props.bemit, props.error, is__disabled, MASK_CONFIG, props.type]);
  const label_class = (0, _react.useMemo)(function () {
    const modifiers = ['date-picker'].concat(props.error ? ['error'] : []);
    if (is__disabled) modifiers.push('disabled');
    return (0, _bemit.default)('c-form-element-label', modifiers);
  }, [props.error, is__disabled]);
  (0, _react.useEffect)(function () {
    if (MASK_CONFIG) setMaskText(MASK_CONFIG.format);
  }, [MASK_CONFIG]);

  // initialisation avec valeur par défaut
  (0, _react.useEffect)(function () {
    if (!input_ref?.current || !MASK_CONFIG) return;
    if (type === 'legacy' && props.value !== undefined) return;
    (function init() {
      input_ref.current.value = default_value ? MASK_CONFIG.humanValueFromIso(default_value) : '';
      input_value_ref.current = input_ref.current.value;
      setUserValue(input_ref.current.value);
      if (default_value) {
        const date = _luxon.DateTime.fromISO(default_value);
        if (date.isValid) {
          setCalendarDate(date.toJSDate());
        }
      }
      onChange({
        e: null,
        name,
        value: default_value || ''
      });
    })();
  }, [default_value, name, MASK_CONFIG, type, onChange, props.value]);

  // masque le calendrier quand on click en dehors
  (0, _react.useEffect)(() => {
    if (is__disabled || !is__visible) {
      setVisibility(false);
      return;
    }
    document.addEventListener('click', listener);
    return () => document.removeEventListener('click', listener);
    function listener(e) {
      // ignore le click s'il est dans le date picker
      if ((0, _nodeIsOrBelongsTo.default)(e?.target, container_ref.current)) return;

      // la navigation dans le picker change le layout et le parent n'existe plus,
      // ça pourraît se produire en cliquant ailleurs mais j'estime le risque
      // très limité
      if (!e?.target?.parentElement) return;
      const target = e?.target;

      // même pb que ci-dessus mais pour un des ancêtres, ce n'est pas idéal mais
      // on vérifie la présence de l'attribut html data-pc-section
      // au pire ce qui peut arriver c'est que s'il y a deux calendriers d'ouvert,
      // rien ne se passe, c'est très acceptable à mon sens
      const is__in_calendar = (target?.getAttributeNames?.() || []).some(attr => attr.startsWith('data-pc-section'));
      if (is__in_calendar) return;
      setVisibility(false);
    }
  }, [is__visible, is__disabled, container_ref]);
  const handleDatePickedChange = (0, _react.useCallback)(function (e) {
    if (!MASK_CONFIG) return;
    if (props.error && removeError) removeError(name);
    const js_date = e.value;
    if (js_date) {
      setCalendarDate(js_date);
    }
    const new_ISO_date = js_date ? _luxon.DateTime.fromJSDate(js_date).toFormat(MASK_CONFIG.iso_format) : '';
    const human_value = new_ISO_date ? MASK_CONFIG.humanValueFromIso(new_ISO_date) : '';
    input_value_ref.current = human_value; // stocke la valeur de l'input

    if (input_ref.current)
      // met à jour le texte de l'input
      {
        input_ref.current.value = input_value_ref.current;
      }
    setUserValue(human_value);
    setVisibility(false);
    onChange({
      e,
      name,
      value: new_ISO_date
    });
  }, [props.error, removeError, name, MASK_CONFIG, onChange]);

  // changement du pullstate ou de props.value
  (0, _react.useEffect)(function () {
    const changed_value = (props.value || '').slice(0, 10);
    if (changed_value === undefined || !input_ref?.current) return;
    if (!changed_value && input_ref.current.value) {
      input_ref.current.value = '';
      setUserValue('');
    } else if (changed_value) {
      const numbers_only = Array.from(changed_value || '').filter(char => numbers_as_str.includes(char)).join('');

      // si la valeur du state n'est pas exploitable on l'ignore
      if (numbers_only.length !== MASK_CONFIG.luxon_format.length) return;
      let as_date = _luxon.DateTime.fromFormat(changed_value, MASK_CONFIG.iso_format);
      if (!as_date.isValid) {
        as_date = _luxon.DateTime.fromFormat(changed_value, MASK_CONFIG.luxon_format);
      }
      if (as_date.isValid) {
        input_ref.current.value = MASK_CONFIG.humanValueFromIso(as_date.toFormat(MASK_CONFIG.iso_format));
        input_value_ref.current = input_ref.current.value;
        setUserValue(input_ref.current.value);
        setCalendarDate(as_date.toJSDate());
      }
    }
  }, [props.value, MASK_CONFIG, type]);
  const handleInputChange = (0, _react.useCallback)(function (e) {
    const last_char = e.target.value[e.target.value.length - 1] || '';

    // si on ajoute un car. à la fin de l'input
    if (e.target.value === (input_value_ref.current || '') + last_char) {
      if (typeof MASK_CONFIG.temperUserInput === 'function') {
        MASK_CONFIG.temperUserInput(e.target, MASK_CONFIG.format);
      }
    }
    const value = e.target.value;

    // masque le calendrier pour laisser place à l'aide à la saisie
    if (value !== input_value_ref.current) {
      setVisibility(false);
    }
    input_value_ref.current = value;
    setUserValue(value);
    const numbers_only = Array.from(value || '').filter(char => numbers_as_str.includes(char)).join('');
    const luxon_format = MASK_CONFIG.luxon_format;
    const format_length = luxon_format.length;
    let new_value = numbers_only;
    if (numbers_only.length === format_length) {
      const as_date = _luxon.DateTime.fromFormat(numbers_only, luxon_format);
      if (as_date.isValid) {
        new_value = as_date.toFormat(MASK_CONFIG.iso_format);
        setCalendarDate(as_date.toJSDate());
      }
    }
    onChange({
      e,
      name,
      value: new_value
    });
  }, [MASK_CONFIG, name, onChange]);
  const handleKeyDown = (0, _react.useCallback)(function (e) {
    if (e.code === 'Escape') setVisibility(false);
    if (e.code === 'Enter' && typeof onEnter === 'function') onEnter(e);
  }, [onEnter]);
  const handleBackgroundClick = (0, _react.useCallback)(function (e) {
    if (e?.target === background_ref?.current) setVisibility(false);
  }, [background_ref]);
  const characters_count = user_value.length;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _bemit.default)('primeract-calendar', modifiers),
    ref: container_ref
  }, props.label ? /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.id || id,
    className: label_class
  }, props.label) : undefined, /*#__PURE__*/_react.default.createElement("div", {
    className: "primeract-calendar__wrapper"
  }, /*#__PURE__*/_react.default.createElement(_InputMask.default, {
    value: mask_text,
    className: "primeract-calendar__mask",
    hide: characters_count
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    className: "primeract-calendar__input",
    onChange: handleInputChange,
    onKeyDown: handleKeyDown,
    ref: input_ref,
    id: id,
    disabled: is__disabled
  }), props['with-picker'] !== false ? /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "primeract-calendar__toggle",
    "aria-labelledby": id + '-toggle',
    onClick: e => setVisibility(true),
    onKeyDown: handleKeyDown,
    disabled: is__disabled
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "u-readers-only",
    id: id + '-toggle'
  }, "Utiliser le calendrier"), /*#__PURE__*/_react.default.createElement(_lu.LuCalendarDays, {
    className: "primeract-calendar__toggle-icon"
  })) : undefined, /*#__PURE__*/_react.default.createElement(_DateVisualHelper.default, {
    mask: mask_text,
    user_value: user_value || '',
    className: "primeract-calendar__visual-helper",
    incomplete: characters_count > 0 && characters_count < MASK_CONFIG.format?.length,
    invalid: characters_count > 0 && characters_count > MASK_CONFIG.format?.length
  }), props['with-picker'] !== false && is__visible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "primeract-calendar__calendar-background",
    onClick: handleBackgroundClick,
    onKeyDown: handleKeyDown,
    ref: background_ref
  }) : undefined, props['with-picker'] !== false ? /*#__PURE__*/_react.default.createElement(_api.PrimeReactProvider, {
    value: prime_params
  }, /*#__PURE__*/_react.default.createElement(_calendar.Calendar, {
    inline: true,
    showIcon: false,
    locale: "fr",
    onChange: handleDatePickedChange,
    className: 'primeract-calendar__calendar ' + (is__visible ? ' visible' : 'hidden'),
    appendTo: "self",
    disabled: is__disabled,
    view: MASK_CONFIG.format === 'YYYY' ? 'year' : 'date',
    showWeek: props['display-week'] === true,
    value: calendar_date
  })) : undefined), props.error ? /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _bemit.default)('c-field-error', ['input'])
  }, /*#__PURE__*/_react.default.createElement(_hi.HiOutlineExclamation, {
    className: "c-field-error__icon"
  }), props.error) : undefined, props.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['primary', 'bg-white']
  }) : undefined);
}, _arePropsEqual.default);
const numbers_as_str = Array.from({
  length: 10
}).map((_v, i) => String(i));
